/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as productsGroupsSlice from './productsGroupsSlice';

export default function* watchProductsGroupsSaga() {
 yield takeLatest(productsGroupsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(productsGroupsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(
  productsGroupsSlice.createItemStart.type,
  commonSagas.createItem,
 );
 yield takeLatest(
  productsGroupsSlice.updateItemStart.type,
  commonSagas.updateItem,
 );
 yield takeLatest(
  productsGroupsSlice.deleteItemsStart.type,
  commonSagas.deleteItems,
 );
 yield takeLatest(
  productsGroupsSlice.deleteItemStart.type,
  commonSagas.deleteItem,
 );
 yield takeLatest(
  productsGroupsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  productsGroupsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  productsGroupsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  productsGroupsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  productsGroupsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
